import Upsertable from '@/models/Upsertable'
import { useAgriOrderProductStore } from '@/stores/agriOrderProductStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class AgriOrderProduct extends Upsertable {
  static store() {
    return useAgriOrderProductStore()
  }

  store() {
    return AgriOrderProduct.store()
  }

  static find(uuid) {
    const obj = AgriOrderProduct.store().find(uuid)
    let agri_order_product = new AgriOrderProduct()
    return Object.assign(agri_order_product, obj)
  }
}

useModelName(AgriOrderProduct, "AgriOrderProduct")
ModelRegistry.register(AgriOrderProduct, "AgriOrderProduct")